import React, { useState, useRef, useEffect } from "react";
import useStyles from "./styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { RESUME, START_OVER } from "../../constants";

const AutoSaveModal = (props) => {
  const classes = useStyles();
  const [resumeType, setResumeType] = useState(RESUME);
  const autoSaveRef = useRef(null);

  const continueButtonHandler = () => {
    props.resumeTypeHandler(resumeType);
  };

  useEffect(() => {
    autoSaveRef.current.focus();
  }, []);

  return (
    <>
      <div className={classes.container} data-testid="autosaveContainer">
        <Box className={classes.modal}>
          <Box className={classes.boxContainer}>
            <Box className={classes.description}>
              <span>Hey there! </span>
              <span>
                You&apos;re back to finish your survey. Do you want to pick up
                where you left off, or start fresh?
              </span>
            </Box>
            <Box>
              <Grid
                item
                className={classes.resumeTypeButtonContainer}
                role="radiogroup"
                aria-labelledby={RESUME}
              >
                <label
                  className={`${classes.resumeType} ${
                    resumeType === RESUME
                      ? classes.selectedOn
                      : classes.selectedOff
                  }`}
                >
                  <input
                    className={classes.resumeInput}
                    type="radio"
                    data-testid="resume-button"
                    onChange={() => setResumeType(RESUME)}
                    checked={resumeType === RESUME}
                    id="resume"
                    ref={autoSaveRef}
                  />
                  <span className={classes.buttonTitle}>Resume</span>
                  <span className={classes.buttonDescription}>
                    If you resume the survey, you will continue from the
                    question where you left off.
                  </span>
                </label>
                <label
                  className={`${classes.resumeType} ${
                    resumeType === START_OVER
                      ? classes.selectedOn
                      : classes.selectedOff
                  }`}
                >
                  <input
                    className={classes.resumeInput}
                    type="radio"
                    data-testid="startOver-button"
                    onChange={() => setResumeType(START_OVER)}
                    checked={resumeType === START_OVER}
                    id="startOver"
                  />
                  <span className={classes.buttonTitle}>Start over fresh</span>
                  <span className={classes.buttonDescription}>
                    If you start from scratch, you will start the survey over
                    from the beginning.
                  </span>
                </label>
              </Grid>
            </Box>

            <Button
              variant="contained"
              disabled={!resumeType}
              className={classes.continueBtn}
              onClick={continueButtonHandler}
            >
              Continue &rarr;
            </Button>
          </Box>
        </Box>
      </div>
    </>
  );
};

export default AutoSaveModal;
